<template>
    <v-app-bar id="nav" flat scroll-behavior="hide" density="comfortable" color="header" class="horizontal nav-teacher">
        <template v-if="school?.type.abbrv === 'WS'">
            <div class="wslogo">
                <RouterLink to="/admin/home"><img :src="`/common/img/ws.png`" /></RouterLink>
                <span>with Giglets Education</span>
            </div>
            <div class="wslogo-gap">&nbsp;</div>
        </template>
        <template v-else>
            <div id="logo">
                <RouterLink to="/admin/home"
                    ><i class="icon icon-giglets"></i><span class="logo-text">giglets</span></RouterLink
                >
            </div>
        </template>
        <v-spacer></v-spacer>
        <div class="nav-wrap">
            <ul>
                <template v-if="!showLightControlPanel">
                    <li class="pupils">
                        <RouterLink to="/admin/view-pupils"
                            ><i class="fa fa-user"></i><span class="title">Pupils</span></RouterLink
                        >
                    </li>
                    <li class="classes">
                        <RouterLink to="/admin/view-classes"
                            ><i class="fa fa-university"></i><span class="title">Classes</span>
                        </RouterLink>
                    </li>
                    <li class="teachersnav">
                        <RouterLink to="/admin/view-teachers"
                            ><i class="fa fa-mortar-board"></i><span class="title">Teachers</span>
                        </RouterLink>
                    </li>
                </template>
                <template v-if="school?.type.abbrv !== 'WS'">
                    <li class="preferences">
                        <RouterLink to="/admin/preferences"
                            ><i class="fa fa-gears"></i><span class="title">Preferences</span>
                        </RouterLink>
                    </li>
                    <li class="reporting">
                        <RouterLink to="/admin/reporting"
                            ><i class="fa fa-pie-chart"></i><span class="title">Reporting</span>
                        </RouterLink>
                    </li>
                </template>
                <li class="resources">
                    <a id="stonly-open-admin-resources" href="#"
                        ><i class="fa fa-chalkboard-user"></i><span class="title">Tutorials</span></a
                    >
                </li>
                <li class="account">
                    <a id="revdrop" ref="revdrop" href="#" @click="displayDropdown = !displayDropdown"
                        ><i class="fa fa-cog"></i> <i class="fa fa-caret-down"></i
                    ></a>
                </li>
            </ul>
        </div>
    </v-app-bar>
    <div
        v-show="displayDropdown"
        id="dropdown"
        v-closable="{
            handler: () => (displayDropdown = false),
            exclude: ['revdrop'],
        }"
    >
        <p>Hi, {{ teacherName }}</p>
        <a @click="swapPortal('teacher')">Back to teacher account</a>
    </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';

const { showLightControlPanel } = useEnv();

const store = useTeacherStore();
store.fetchTeacher();
store.fetchSchool();
const { teacher, school } = storeToRefs(store);

const displayDropdown = ref(false);
const title = ref('');
const bodyClasses = useBodyClasses();

watchEffect(() => {
    title.value = school.value && school.value.type.abbrv === 'WS' ? 'WorldStories' : 'Giglets';
    bodyClasses.addClasses(['teachers']);
});

const teacherName = computed(() => {
    if (!teacher.value || !teacher.value.name) {
        return '';
    }
    return teacher.value.name.length < 20 ? teacher.value.name : teacher.value.name.substring(0, 20) + '...';
});

function swapPortal(type: 'teacher') {
    useSwapPortal(type);
}

useHead({ title });
</script>
<style lang="scss" scoped>
.font-size-icon {
    position: relative !important;
    max-width: 24px !important;
    overflow: visible !important;

    .small {
        left: 15px !important;
        font-size: 18px !important;
    }

    .large {
        font-size: 24px !important;
    }
}
</style>
